import { MutableRefObject } from 'react';
import SwitchToggle from 'components/ui/Switch';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';

type CreditToggleCellProps = {
    checked: boolean;
    disabled?: boolean;
    skuId: string;
    onToggle: (checked: boolean) => void;
    rowIndex: number;
    colIndex: number;
    cellRefPrefix: string;
    // cellInputRefs?: MutableRefObject<{
    //     [key: string]: HTMLInputElement | HTMLSelectElement | HTMLButtonElement | HTMLDivElement | null;
    // }>;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown?: (e: any, itemId: any, rowIndex: any, colIndex: any) => void;
    itemId: number | string;
};

const CreditToggleCell = ({
    checked,
    disabled = false,
    skuId,
    onToggle,
    rowIndex,
    colIndex,
    cellRefPrefix,
    cellInputRefs,
    handleArrowKeyDown,
    itemId,
}: CreditToggleCellProps) => {
    return (
        <SwitchToggle
            ref={(el) => {
                if (cellInputRefs && cellInputRefs.current) {
                    cellInputRefs.current[`${cellRefPrefix}${rowIndex}-${colIndex}`] = el;
                }
            }}
            checked={checked}
            disabled={disabled}
            skuId={skuId}
            onHandleToggle={onToggle}
            onKeyDown={(e: any) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (disabled) return;
                    onToggle(!checked);
                    return;
                }
                handleArrowKeyDown?.(e, itemId, rowIndex, colIndex);
            }}
        />
    );
};

export default CreditToggleCell;
